import type { RefObject } from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Lleva el contenedor scrolleable al tope en cada cambio de ruta.
 * El scroll vive en el `<main>` del layout (`overflow-y-auto`), no en el
 * documento, así que `window.scrollTo` no aplica.
 */
export function useScrollToTopOnNavigate(ref: RefObject<HTMLElement | null>): void {
  const { pathname } = useLocation();

  // biome-ignore lint/correctness/useExhaustiveDependencies: el reset se dispara por cambio de pathname, no por identidad del ref
  useEffect(() => {
    const el = ref.current;
    if (el) el.scrollTop = 0;
  }, [pathname]);
}
